import { render } from "./RiProfile.vue?vue&type=template&id=45762eec"
import script from "./RiProfile.vue?vue&type=script&lang=js"
export * from "./RiProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45762eec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45762eec', __exports__)) {
    api.reload('45762eec', __exports__)
  }
  
  module.hot.accept("./RiProfile.vue?vue&type=template&id=45762eec", () => {
    api.rerender('45762eec', render)
  })

}


export default __exports__